export default "__VITE_ASSET__D$KSuhBE__"